import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/wxWork.jpg'
import _imports_1 from '@/assets/qrCode.png'


const _withScopeId = n => (_pushScopeId("data-v-0172ebc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer sys_BgColor" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "|", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cont" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "iconfont icon-telephone" }, "业务联系"),
    /*#__PURE__*/_createElementVNode("div", null, "客服联系：400-8039-718"),
    /*#__PURE__*/_createElementVNode("div", null, "销售联系：18028211516、18028912996"),
    /*#__PURE__*/_createElementVNode("div", null, "市场合作：tom.huang@hrbgc.com")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "cont" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "iconfont icon-shouhuodizhi" }, "广东"),
    /*#__PURE__*/_createElementVNode("div", null, "广东省东莞市南城街道元美西路8号1栋18楼"),
    /*#__PURE__*/_createElementVNode("div", null, "广东优才信息科技有限公司")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "code_img textCenter" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("div", { class: "f_12" }, "企业微信")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "code_img textCenter" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
    /*#__PURE__*/_createElementVNode("div", { class: "f_12" }, "优才小程序")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "textCenter f_12" }, [
  /*#__PURE__*/_createElementVNode("span", null, "© Copyright 2020 广东优才信息科技有限公司"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "pointer textLink marginL10",
    href: "https://beian.miit.gov.cn/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "粤ICP备2023002766号-1")
], -1))

import { getCurrentInstance, ref, reactive, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  emits: ["updateScroll"],
  setup(__props, { emit }: { emit: ({
  (e: "updateScroll", value: string): void;
}), expose: any, slots: any, attrs: any }) {


const route = useRoute();
const router = useRouter();
let list = [
  { title: "首页", type: 1, route: "home", path: "/home" },
  { title: "解决方案", type: 2, route: "scheme", path: "/scheme" },
  { title: "背调流程", type: 3, route: "flowPath", path: "/flowPath" },
  { title: "背调内容", type: 4, route: "surveyDetails", path: "/surveyDetails" },
  { title: "API服务", type: 5, route: "apiServe", path: "/apiServe" },
  { title: "竞业管理", type: 6, route: "competitionAgree", path: "/competitionAgree" },
  { title: "关于我们", type: 7, route: "aboutUs", path: "/aboutUs" },
];
// 路由跳转
const toRoute = (key) => {
  for (const i in list) {
    let item = list[i];
    if (key == item.type) {
      router.push(item.path);
      if (item.route == route.name) {
        return;
      }
      setTimeout(() => {
        nextTick(() => {
          window.scrollTo({
            top: 0,
          });
          emit("updateScroll", "1");
        });
      }, 80);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "pointer select_none",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toRoute(1)))
        }, "首页"),
        _hoisted_4,
        _createElementVNode("div", {
          class: "pointer select_none",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (toRoute(2)))
        }, "解决方案"),
        _hoisted_5,
        _createElementVNode("div", {
          class: "pointer select_none",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (toRoute(3)))
        }, "背调流程"),
        _hoisted_6,
        _createElementVNode("div", {
          class: "pointer select_none",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (toRoute(4)))
        }, "背调内容"),
        _hoisted_7,
        _createElementVNode("div", {
          class: "pointer select_none",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (toRoute(5)))
        }, "API服务"),
        _hoisted_8,
        _createElementVNode("div", {
          class: "pointer select_none",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (toRoute(6)))
        }, "竞业管理"),
        _hoisted_9,
        _createElementVNode("div", {
          class: "pointer select_none",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (toRoute(7)))
        }, "关于我们")
      ]),
      _hoisted_10,
      _createVNode(_component_el_divider),
      _hoisted_11
    ])
  ]))
}
}

})